import React from 'react';
import { useEndpointMonitor } from '../../hooks/useEndpointMonitor';

/**
 * Composant pour afficher le statut des endpoints
 */
const EndpointMonitor = () => {
  const endpoints = [
    { name: 'configV3', label: 'Config V3' },
    { name: 'configV9', label: 'Config V9' },
    { name: 'llmModels', label: 'LLM Models' },
    { name: 'sessions', label: 'Sessions' },
  ];

  const { status, isMonitoring, startMonitoring, stopMonitoring } = useEndpointMonitor(
    endpoints,
    5000
  );

  const getStatusColor = (endpointStatus) => {
    if (!endpointStatus) return 'bg-slate-700';
    if (endpointStatus.status === 'success') return 'bg-green-500';
    if (endpointStatus.status === 'error') return 'bg-red-500';
    return 'bg-yellow-500';
  };

  const getStatusIcon = (endpointStatus) => {
    if (!endpointStatus) return '⚪';
    if (endpointStatus.status === 'success') return '✅';
    if (endpointStatus.status === 'error') return '❌';
    return '⚠️';
  };

  return (
    <div className="bg-slate-800 border border-slate-700 rounded-2xl p-4">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-white font-medium">Monitoring Endpoints</h3>
          <p className="text-xs text-slate-400">
            {isMonitoring ? 'Actif' : 'Inactif'}
          </p>
        </div>
        <button
          onClick={isMonitoring ? stopMonitoring : startMonitoring}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
            isMonitoring
              ? 'bg-red-500 hover:bg-red-600 text-white'
              : 'bg-green-500 hover:bg-green-600 text-white'
          }`}
        >
          {isMonitoring ? 'Arrêter' : 'Démarrer'}
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {endpoints.map((endpoint) => {
          const endpointStatus = status[endpoint.name];
          return (
            <div
              key={endpoint.name}
              className="bg-slate-900 rounded-lg p-3 border border-slate-700"
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="text-lg">{getStatusIcon(endpointStatus)}</span>
                <span className="text-white text-sm font-medium">{endpoint.label}</span>
              </div>
              {endpointStatus && (
                <div className="space-y-1">
                  {endpointStatus.status === 'success' && endpointStatus.duration && (
                    <p className="text-xs text-slate-400">
                      {endpointStatus.duration}ms
                    </p>
                  )}
                  {endpointStatus.status === 'error' && (
                    <p className="text-xs text-red-400 truncate">
                      {endpointStatus.error}
                    </p>
                  )}
                  {endpointStatus.timestamp && (
                    <p className="text-xs text-slate-500">
                      {new Date(endpointStatus.timestamp).toLocaleTimeString()}
                    </p>
                  )}
                </div>
              )}
              <div
                className={`mt-2 h-1 rounded-full ${getStatusColor(endpointStatus)}`}
              ></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EndpointMonitor;



